export const CHAT_EVENT = {
  AT_CHAT_NAVBAR_ACTION: 'at_chat_navbar_action',
  AT_CHAT_CARD_ACTION: 'at_chat_card_action',
} as const

export const CHAT_INTERACTIONS = {
  SEEN: 'seen',
  CLICK: 'click',
} as const
